exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1}!../../../../../../node_modules/postcss-loader/lib/index.js!shared/css/buttons.css"), undefined);

// module
exports.push([module.id, "._1HkEGPpE9GWxC24KDfMDtS{margin-left:4px;padding:0}._1HkEGPpE9GWxC24KDfMDtS,._2VeDI0mfu7HiLdtoPcFe0K{display:inline-block;vertical-align:top;width:36px}._2VeDI0mfu7HiLdtoPcFe0K{color:#fff;font-size:20px;height:36px;line-height:42px;text-align:center;text-indent:-1px}._1GV5lyRcwb0uLlC7XoJivt{background-color:#e42c26}.cMlLKVKhsHFAMfNL3fw-d{background-color:#00adef}", ""]);

// exports
exports.locals = {
	"button": "" + require("-!../../../../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1}!../../../../../../node_modules/postcss-loader/lib/index.js!shared/css/buttons.css").locals["button"] + "",
	"mediaButton": "_1HkEGPpE9GWxC24KDfMDtS " + require("-!../../../../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1}!../../../../../../node_modules/postcss-loader/lib/index.js!shared/css/buttons.css").locals["button"] + "",
	"mediaIcon": "_2VeDI0mfu7HiLdtoPcFe0K",
	"youtube": "_1GV5lyRcwb0uLlC7XoJivt _2VeDI0mfu7HiLdtoPcFe0K ss-social ss-youtube",
	"vimeo": "cMlLKVKhsHFAMfNL3fw-d _2VeDI0mfu7HiLdtoPcFe0K ss-social ss-vimeo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1}!./node_modules/postcss-loader/lib!./js/embeds/gif/components/footer/media-button/media-button.css
// module id = 1RfC
// module chunks = gifEmbed